var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { merge } from "lodash";
import createMuiTypography from "@material-ui/core/styles/createTypography";
import { typography } from "./generated";
// See: https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/styles/createTypography.js#L3
export var round = function (value) { return Math.round(value * 1e5) / 1e5; };
export var createTypography = function (palette, overrides) {
    if (overrides === void 0) { overrides = {}; }
    var fontFamily = overrides.fontFamily ||
        "Inter, fakt-web, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
    var fontFamilyMonospace = overrides.fontFamilyMonospace || "'Roboto Mono', monospace";
    var fontWeightMapping = {
        light: overrides.fontWeightLight || 300,
        regular: overrides.fontWeightRegular || 400,
        medium: overrides.fontWeightMedium || 500,
        semibold: overrides.fontWeightSemibold || 600,
        bold: overrides.fontWeightBold || 700,
    };
    var buildVariant = function (_a) {
        var fontSizePx = _a.fontSizePx, lineHeightPx = _a.lineHeightPx, letterSpacingPx = _a.letterSpacingPx, fontWeightKey = _a.fontWeightKey, _b = _a.variantFontFamily, variantFontFamily = _b === void 0 ? fontFamily : _b, textCase = _a.textCase;
        var variantStyle = {
            fontFamily: variantFontFamily,
            fontSize: round(fontSizePx / 16) + "rem",
            fontWeight: fontWeightMapping[fontWeightKey],
            letterSpacing: round(letterSpacingPx / fontSizePx) + "em",
            lineHeight: round(lineHeightPx / fontSizePx),
        };
        if (textCase === "UPPER") {
            variantStyle.textTransform = "uppercase";
        }
        return variantStyle;
    };
    var defaultOptions = {
        fontWeightMedium: fontWeightMapping.medium,
        fontWeightBold: fontWeightMapping.bold,
        fontWeightLight: fontWeightMapping.light,
        fontWeightRegular: fontWeightMapping.regular,
        fontWeightSemibold: fontWeightMapping.semibold,
        fontFamily: fontFamily,
        fontFamilyMonospace: fontFamilyMonospace,
        h1: buildVariant(typography.headingsH1),
        h2: buildVariant(typography.headingsH2),
        h3: buildVariant(typography.headingsH3),
        h4: buildVariant(typography.headingsH4),
        h5: buildVariant(typography.headingsH5),
        h6: buildVariant(typography.headingsH6),
        subtitle1: buildVariant(typography.subtitlesLarge),
        subtitle2: buildVariant(typography.subtitlesDefault),
        body1: buildVariant(typography.bodyLarge),
        body2: buildVariant(typography.bodyDefault),
        button: __assign(__assign({}, buildVariant(typography.formsButton)), { textTransform: "none" }),
        caption: buildVariant(typography.captionDefault),
        overline: __assign(__assign({}, buildVariant(typography.formsOverline)), { textTransform: "uppercase", 
            // the rounding function for the px -> em is causing this to round down.
            lineHeight: 1.64 }),
        code1: buildVariant(__assign(__assign({}, typography.codeDefault), { variantFontFamily: fontFamilyMonospace })),
        code2: buildVariant(__assign(__assign({}, typography.codeSmall), { variantFontFamily: fontFamilyMonospace })),
        label: buildVariant(typography.formsLabel),
        input: buildVariant(typography.formsTextField),
    };
    return createMuiTypography(palette, merge(defaultOptions, overrides));
};
